var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamcity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#0cb0f2;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -382.71,
    y1: 1211.72,
    x2: -385.94,
    y2: 1207.73,
    gradientTransform: "translate(7578.66 -23542.92) scale(19.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0cb0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#10adf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1ea5f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3497f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5283f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#796af9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#905cfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -386.38,
    y1: 1215.2,
    x2: -384.76,
    y2: 1211.46,
    gradientTransform: "translate(7578.66 -23542.92) scale(19.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0cb0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0db2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#12b7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#19c0ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#23ccac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#30dc85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3bea62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -384.16,
    y1: 1210.29,
    x2: -381,
    y2: 1206.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -382.93,
    y1: 1207.49,
    x2: -382.93,
    y2: 1213.89,
    gradientTransform: "translate(7578.66 -23542.92) scale(19.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "teamcity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.89,4.6a39.06,39.06,0,0,0-8.64-3.12C23.1-8.05-6.73,31.32,9.67,67.09c.16.16,29.21,63.89,33.9,74,0,0,53.43-24.53,64.36-49.68C118.06,68,101,25.25,97.86,18.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.6,75.7a38.06,38.06,0,0,0-13.43-12.5c-.16,0-37.65-20.62-37.65-20.62S12.79,117.21,12.65,117.41C-1.88,134-5.16,160.21,11.56,183a39.4,39.4,0,0,0,20.31,14.37c15.15,4.69,28.59,2.81,39.84-3.12.31-.16,105.76-56.08,106.07-56.4,20.61-10.78,30.15-38.27,14.83-62.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.18,59.31,25.81,101.49,12.48,117.41C-2,134-5.33,160.21,11.39,183A39.4,39.4,0,0,0,31.7,197.39c15.15,4.69,28.74,2.81,40-3.12,0,0,2.66-1.41,7.19-3.91,14.28-7.72,34-59.6,47.41-99.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.2,99.91l27.32-57.69a.16.16,0,0,1,.16-.16c.16-.47,2.34-6.09,2.5-6.41a26.56,26.56,0,0,0-2.81-24.84A22.32,22.32,0,0,0,127.46,1a25.62,25.62,0,0,0-26.71,8.9c-.16.16-6.09,7-6.09,7L50.91,70.81Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.63,37.42h125v125h-125Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67,65.07H50.13V54.14H95.9V65.07H79.19v43.1H67Zm28.9,16.2C95.9,65.65,107.46,53,124.18,53c10.15,0,16.4,3.44,21.4,8.44l-7.65,8.75c-4.22-3.75-8.44-6.09-13.9-6.09-9.06,0-15.78,7.65-15.78,16.87v.16c0,9.37,6.41,17,15.78,17,6.25,0,10-2.5,14.22-6.41l7.65,7.65c-5.62,5.94-11.72,9.69-22.18,9.69A27.2,27.2,0,0,1,95.9,82.51q0-.62,0-1.23M50.13,137.41H95.9v8.28H50.13Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamcity);
export default __webpack_public_path__ + "static/media/teamcity.d1483506af44178c1ee003974f483cba.svg";
export { ForwardRef as ReactComponent };